/**
 * Клавиатура для элементов, которые кнопкой стать не могут.
 * <p>
 * Карточка практики раскрывает ответ по клику в любое место — это не кнопка:
 * внутри неё уже есть кнопки (озвучка, оценка), а кнопка внутри кнопки невалидна.
 * Поэтому карточка получает фокус и обработчик клавиш, но не роль: роль обещала бы
 * читалке экрана то, чем элемент не является.
 */
export const activateOnKey = (onActivate) => (event) => {
    // Событие от вложенной кнопки всплывает сюда, и снять у него действие по умолчанию
    // значило бы отменить её нажатие: Enter на «озвучить» не озвучивал бы, а раскрывал
    // ответ. Реагируем только на клавишу, адресованную самому контейнеру.
    if (event.target !== event.currentTarget) {
        return;
    }
    if (event.key !== 'Enter' && event.key !== ' ') {
        return;
    }
    // Пробел на большом контейнере иначе прокрутит страницу вместо ответа
    event.preventDefault();
    onActivate(event);
};
